"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MeterReadsDatepicker = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../shared/core");
var components_1 = require("../../../../shared/core/components");
var constants_1 = require("../../constants");
var copy_1 = require("../../copy");
var utils_1 = require("../../utils");
//Without time string, date is created at midnight UTC. We want midnight local
var toLocalMidnight = function (date) {
    return new Date("".concat(date.toString(), ":00:00"));
};
var MeterReadsDatepicker = function (_a) {
    var _b;
    var id = _a.id, supplyStartDate = _a.supplyStartDate, setDate = _a.setDate, error = _a.error, readings = _a.readings, hint = _a.hint;
    var copy = (0, core_1.useCopy)(copy_1.defaultOptions).copy;
    // pick latest of following as oldest date for which we can submit a meter reading
    // 1. today - 9 days
    // 2. supply start date
    // 3. day meter installed (MEx event)
    var nineDaysAgo = (0, date_fns_1.subDays)((0, date_fns_1.startOfToday)(), constants_1.SUBMISSION_WINDOW_DAYS);
    var lastMexDate = (_b = (0, utils_1.getLatestMeterExchangeReading)(readings)) === null || _b === void 0 ? void 0 : _b.formattedReadingDate;
    var earliestSubmitDate = (0, date_fns_1.max)(__spreadArray([
        nineDaysAgo,
        supplyStartDate
    ], __read((lastMexDate ? [lastMexDate] : [])), false));
    return (react_1.default.createElement(components_1.DatepickerField, { id: id, label: copy('readingDateLabel'), error: error, defaultValue: "Today", onChange: setDate, isDateUnavailable: function (date) {
            return (0, date_fns_1.isBefore)(toLocalMidnight(date), earliestSubmitDate) ||
                (0, date_fns_1.isAfter)(toLocalMidnight(date), (0, date_fns_1.startOfToday)());
        }, hint: hint }));
};
exports.MeterReadsDatepicker = MeterReadsDatepicker;
